<template>
  <div class="vidclcont between">
    <div class="content">
      <div class="vidcl_title flex_start">
        <div :class="{ actitle: isactitle == 0 }" @click="clitag(0)">
          最新视频
        </div>
        <div :class="{ actitle: isactitle == 1 }" @click="clitag(1)">
          <img src="~assets/laws/zuire.png" />
          热门推荐
        </div>
      </div>
      <div class="videolist">
        <div
          class="videoitem flex_start"
          v-for="(item, index) in videolist"
          :key="index"
          @click="tojump(item)"
        >
          <div class="cove">
            <viimg :imgurl="item.preview_pic" />
          </div>
          <div class="det">
            <div class="dv1">{{ item.title }}</div>
            <div class="dv2">
              <img :src="item.avatar" alt="" />
              {{item.true_name}}律师
            </div>
            <div class="dv3">
              {{ item.content | toEllipsisFilter(50) }}
            </div>
            <div class="dv4 flex_start">
              <div class="center">
                <svg-icon icon-class="time" class="svgimg" />
                {{ item.updated_at || "2021-04-05" }}
              </div>
              <div class="center">
                <svg-icon icon-class="linear-play" class="svgimg" />
                {{ item.view_num }}次播放
              </div>
            </div>
          </div>
        </div>
        <div class="pagination mt20">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-count="pageCount"
            :current-page="currentPage"
            :pager-count="5"
            @current-change="turnpage"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="sideadv">
      <videolist class="vrk" :num="4" title="视频问答排行榜" />
      <articlelist
        class="arclerk"
        :list="gztllist"
        title="精选解答推荐"
        @Inabatch="Inabatch"
      />
      <audiolist class="aork" :list="tjaudio" title="语音推荐" />
    </div>
  </div>
</template>

<script>
import viimg from "../componens/viimg";
import videolist from "../componens/videolist";
import articlelist from "../componens/articlelist";
import audiolist from "../componens/audiolist";
export default {
  components: {
    viimg,
    videolist,
    articlelist,
    audiolist,
  },
  data: () => ({
    isactitle: 0,
    currentPage: 1, //当前
    pageCount: 17, //总页数
    total: 17, //总条目
    videolist: [],
    gztllist: [],
    tjaudio: [],
    jdpage: 1,
  }),
  computed:{
    vicolId(){
      return this.$store.state.laws.vicolId
    }
  },
  beforeMount() {
    this.getvideolist();
    this.getgztl();
    this.gettjaudio();
  },
  methods: {
    turnpage(e) {
      this.currentPage = e;
      this.getvideolist();
    },
    clitag(index) {
      this.isactitle = index;
      this.currentPage = 1;
      this.getvideolist();
    },
    getvideolist() {
      let data = {
        limit: 6,
        cat_id:this.vicolId,
        order: this.isactitle == 0 ? "new" : "hot",
        page: this.currentPage,
      };
      console.log();
      this.$http.laws.getvideolist(data).then((res) => {
        console.log("res", res);
        this.total = res.data.total;
        this.pageCount = res.data.last_page;
        this.videolist = res.data.data;
      });
    },
    tojump(item) {
      this.$router.push({
        path: "/laws/videoimdet",
        query: {
          videoinId: item.id,
        },
      });
    },
    getgztl() {
      let data = {
        limit: 5,
        page: this.jdpage,
        order: "hot",
      };
      this.$http.laws.getarticlist(data).then((res) => {
        this.gztllist = res.data.data;
      });
    },
    gettjaudio() {
      let data = {
        limit: 4,
        page: 1,
        order: "hot",
      };
      this.$http.laws.getaudiolist(data)
      .then((res) => {
        this.tjaudio = res.data.data
      });
    },
    Inabatch() {
      this.jdpage++;
      this.jdpage>3?this.jdpage=1:'';
      this.getgztl();
    },
  },
  watch:{
    vicolId(){
      this.currentPage=1
      this.getvideolist()
    }
  }
};
</script>

<style lang="scss" scoped>
.vidclcont {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  align-items: flex-start;
  .content {
    width: 856px;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    .vidcl_title {
      width: 100%;
      height: 57px;
      border-bottom: 1px solid #eeeeee;
      div {
        cursor: pointer;
        margin-left: 40px;
        img {
          margin-bottom: 2px;
          width: 13px;
          height: 19px;
        }
      }
      .actitle {
        color: #0465ea;
        position: relative;
        &::after {
          position: absolute;
          content: "";
          bottom: -18px;
          left: 50%;
          transform: translateX(-50%);
          background-color: #0465ea;
          width: 58px;
          height: 4px;
        }
      }
    }
    .videolist {
      padding-bottom: 30px;
      .videoitem {
        cursor: pointer;
        padding: 30px 24px;
        border-bottom: 1px solid #eee;
        align-items: flex-start;
        .cove {
          margin-right: 30px;
          width: 366px;
          height: 200px;
        }
        .det {
          color: #333333;
          width: 400px;
          .dv1 {
            font-size: 18px;
            line-height: 20px;
            margin-top: 12px;
          }
          .dv2 {
            margin: 16px 0 14px;
            font-size: 14px;
            img {
              width: 40px;
              height: 40px;
              margin-right: 11px;
            }
          }
          .dv3 {
            font-size: 14px;
            color: #666666;
            line-height: 26px;
          }
          .dv4 {
            margin-top: 10px;
            font-size: 12px;
            color: #999999;
            line-height: 28px;
            div {
              margin-right: 52px;
            }
            .svgimg {
              font-size: 12px;
              margin-right: 8px;
            }
          }
        }

        &:hover {
          .det .dv1 {
            color: #0465ea;
          }
        }
      }
    }
  }
  .sideadv {
    width: 314px;
    .vrk {
      width: 314px;
      height: 490px;
    }
    .arclerk {
      margin-top: 30px;
      width: 314px;
      height: 586px;
    }
    .aork {
      margin-top: 30px;
      width: 314px;
    }
  }
  .pagination {
    text-align: center;
    ::v-deep .el-pagination.is-background .btn-next,
    ::v-deep .el-pagination.is-background .btn-prev,
    ::v-deep .el-pagination button,
    ::v-deep .el-pagination span:not([class*="suffix"]),
    ::v-deep .el-pagination.is-background .el-pager li {
      min-width: 36px;
      height: 36px;
      line-height: 36px;
    }
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active,
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: #ffffff !important;
      background: #0057ff !important;
    }
  }
}
</style>